function initPopularProductsSlider(section) {
    if (section.classList.contains("slider_started")) return;
    section.classList.add("slider_started");
  
    const id = section.id;
    const autoplay = section.dataset.autoplay === "true";
    const stopAutoplay = section.dataset.stopAutoplay === "true";
    const delay = parseInt(section.dataset.delay, 10) * 1000;
    const speed = parseInt(section.dataset.speed, 10) * 1000;
    const slidesPerView = parseInt(section.dataset.productsToShow, 10) || 4;
  
    const swiper = new Swiper(`#${id} .popular-products-swiper`, {
      speed: speed,
      loop: true,
      spaceBetween: 24,
      slidesPerView: slidesPerView,
      navigation: {
        nextEl: `#${id} .product-button-next`,
        prevEl: `#${id} .product-button-prev`,
      },
      scrollbar: {
        el: `#${id} .swiper-scrollbar`,
        draggable: true,
      },
      autoplay: autoplay
        ? { delay: delay, disableOnInteraction: false }
        : false,
      breakpoints: {
        768: { slidesPerView: slidesPerView }, // Tablet/Desktop
        0: { slidesPerView: 1.2 }               // Mobile
      }
    });
  
    if (autoplay && stopAutoplay) {
      const content = section.querySelector(".popular-products__content");
      content.addEventListener("mouseenter", () => swiper.autoplay.stop());
      content.addEventListener("mouseleave", () => swiper.autoplay.start());
    }
  }
  
  // Run on page load
  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".popular-products-section").forEach(initPopularProductsSlider);
  });
  
  // Run when Shopify dynamically loads a section
  document.addEventListener("shopify:section:load", (e) => {
    const section = e.target.querySelector(".popular-products-section");
    if (section) initPopularProductsSlider(section);
  });
  